// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"e72d100c","175":"90a3b3a3","610":"d32c3f0e"}[chunkId] + ".js";
};